import { render, staticRenderFns } from "./box.vue?vue&type=template&id=902abd60&"
import script from "./box.vue?vue&type=script&lang=ts&"
export * from "./box.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "box.vue"
export default component.exports